import { coerceEnumByLabel } from '../../lib/api/coerceEnum';
import type { ContactType } from './types';

export const CONTACT_TYPE_LABELS: Record<string, ContactType> = {
  Individual: 0,
  Organization: 1,
};

export function normalizeContactType(value: unknown): ContactType {
  return coerceEnumByLabel(value, CONTACT_TYPE_LABELS) ?? 0;
}

/** Query-string value for GET /contacts (enum name binds reliably; 0 can be skipped by some binders). */
export function contactTypeToApiQueryValue(value: ContactType): string {
  return normalizeContactType(value) === 1 ? 'Organization' : 'Individual';
}

export function readContactTypeField(item: {
  contactType?: unknown;
  ContactType?: unknown;
}): unknown {
  return item.contactType ?? item.ContactType;
}

export function isOrganizationContactType(value: unknown): boolean {
  return normalizeContactType(value) === 1;
}

export function contactTypeLabel(value: unknown): string {
  return isOrganizationContactType(value) ? 'Organization' : 'Individual';
}

export function contactTypeListTitle(value: unknown): string {
  return isOrganizationContactType(value) ? 'Organizations' : 'Individuals';
}

export function contactTypeListSubtitle(value: unknown): string {
  return isOrganizationContactType(value)
    ? 'Search, filter, and manage organization contacts in your workspace.'
    : 'Search, filter, and manage individual contacts in your workspace.';
}

export function contactDisplayName(item: {
  displayName?: string | null;
  companyName?: string | null;
  name?: string | null;
  contactType?: unknown;
}): string {
  if (isOrganizationContactType(item.contactType)) {
    return item.companyName ?? item.name ?? item.displayName ?? 'Unknown';
  }
  return item.name ?? item.companyName ?? item.displayName ?? 'Unknown';
}

export function contactSecondaryName(item: {
  displayName?: string | null;
  companyName?: string | null;
  name?: string | null;
  contactType?: unknown;
}): string | null {
  if (isOrganizationContactType(item.contactType)) {
    return null;
  }
  const company = item.companyName;
  return company ?? null;
}
